import { ArrayBase } from '../ArrayBase';

export class Country extends ArrayBase {
  static create() {
    return ['United States'];
  }
}
